import { ReactElement } from 'react';

export default function Skeleton(props: { isPending: boolean; children: any }): ReactElement {
  const { isPending, children } = props;

  return (
    <>
      {isPending ? (
        <div className="cr-mx-auto cr-w-full cr-max-w-sm cr-rounded-md cr-border cr-border-blue-300 cr-p-4">
          <div className="cr-flex cr-animate-pulse cr-space-x-4">
            <div className="cr-size-10 cr-rounded-full cr-bg-gray-200"></div>
            <div className="cr-flex-1 cr-space-y-6 cr-py-1">
              <div className="cr-h-2 cr-rounded cr-bg-gray-200"></div>
              <div className="cr-space-y-3">
                <div className="cr-grid cr-grid-cols-3 cr-gap-4">
                  <div className="cr-col-span-2 cr-h-2 cr-rounded cr-bg-gray-200"></div>
                  <div className="cr-col-span-1 cr-h-2 cr-rounded cr-bg-gray-200"></div>
                </div>
                <div className="cr-h-2 cr-rounded cr-bg-gray-200"></div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        children
      )}
    </>
  );
}
